// Shared building blocks from the design (components/ui.tsx). Added as screens need them.
import { ConversationLoader } from "./OlliLogo";

export function PrimaryButton({ loading, loadingLabel, children, className = "", ...props }) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={`flex h-12 items-center justify-center gap-2 rounded-full bg-sun px-6 text-body font-semibold text-ink hover:brightness-95 disabled:cursor-not-allowed disabled:bg-mist disabled:text-muted ${className}`}
    >
      {loading ? (
        <>
          <ConversationLoader size={20} tone="white" />
          {loadingLabel}
        </>
      ) : (
        children
      )}
    </button>
  );
}
